/**
 * @generated SignedSource<<e44331ae96125e0a7134992d25f86737>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamSettingsPopover_Store$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TeamSettingsPopover_Store";
};
export type TeamSettingsPopover_Store$key = {
  readonly " $data"?: TeamSettingsPopover_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamSettingsPopover_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamSettingsPopover_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "1a4f0004dd22993890ef73e8388483ea";

export default node;
